// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import OrderHeader, { OrderHeaderProps } from "@store/Library/Components/Toolkit/Order/OrderHeader";
import constants from "@store/constants";
import { useCurrentPage } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import React, { FC } from "react";

export interface FeatureNotesListHeaderProps extends WidgetProps {}

export interface FeatureNotesListHeaderStyles {
    orderHeader?: OrderHeaderProps;
}

export const featureNotesListHeaderStyles: FeatureNotesListHeaderStyles = {};

const styles = featureNotesListHeaderStyles;

const FeatureNotesListHeader: FC<FeatureNotesListHeaderProps> = ({ id }) => {
    const {
        fields: { title },
    } = useCurrentPage();

    return (
        <OrderHeader {...styles.orderHeader} title={title}>
            <Zone contentId={id} zoneName="ActionButtons" />
        </OrderHeader>
    );
};

const widgetModule: WidgetModule = {
    component: FeatureNotesListHeader,
    definition: {
        group: constants.widgetGroup.featureNotesList,
        displayName: "Header",
        allowedContexts: [constants.pageType.featureNotesList],
    },
};

export default widgetModule;
